import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { PrimaryButton, SecondaryButton, FilledDestructiveButton } from './Buttons';

const ConfirmDialog = ({ 
    open, 
    onClose, 
    onConfirm, 
    title = 'Confirm Action', 
    message = 'Are you sure you want to proceed?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    severity = 'warning',
    icon = <WarningIcon color="warning" />
}) => {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                elevation: 8,
                sx: {
                    borderRadius: 4
                }
            }}
        >
            <DialogTitle sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                pb: 1,
                borderBottom: '1px solid',
                borderColor: 'divider'
            }}>
                {icon}
                <Typography variant="h6" component="span">
                    {title}
                </Typography>
            </DialogTitle>
            
            <DialogContent sx={{ pt: 2, pb: 1 }}>
                <Typography variant="body1" color="text.secondary">
                    {message}
                </Typography>
            </DialogContent>
            
            <DialogActions sx={{ px: 3, pb: 2, gap: 1, justifyContent: 'flex-end' }}>
                <SecondaryButton onClick={onClose}>{cancelText}</SecondaryButton>
                {severity === 'error' ? (
                    <FilledDestructiveButton onClick={handleConfirm}>{confirmText}</FilledDestructiveButton>
                ) : (
                    <PrimaryButton onClick={handleConfirm}>{confirmText}</PrimaryButton>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog; 